<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <form-select v-if="!client" :model="filterFormModel" attribute="group" class="mr-1 mb-1" :options="[
                    {value: 'day', text: $t('byDay')},
                    {value: 'gateway', text: $t('byGateway')},
                    {value: 'client', text: $t('byClient')},
                    {value:'sales',text:$t('bySales')},
                    {value: 'number', text: $t('byNumber')},
                    {value: 'host', text:$t('phoneHost')},
                    {value: 'network', text:$t('network')}]"></form-select>
            <client-select v-if="!client" :model="filterFormModel"  attribute="client" @input="load" :isFilter="true" :place-holder="$t('selectClient') "
                           class="mr-1 mb-1"></client-select>
            <time-range-picker :model="filterFormModel" class="mr-1 mb-1" :label="$t('time')" :default-shortcut="2"></time-range-picker>
            <form-select :model="filterFormModel" attribute="sort" class="mr-1 mb-1" v-if="filterFormModel.group !== 'day'" :options="[
                  {value: 'chargedFee', text: $t('chargedFeeDesc')},
                  {value: 'offNetworkFee', text: $t('offNetworkFeeDesc')},
                  {value: 'success', text: $t('successDesc')},
                  {value: 'offNetwork', text: $t('offNetworkDesc')},
                  {value: 'chargeDuration', text: $t('chargeDurationDesc')},
              ]"></form-select>
            <host-select :model="filterFormModel" class="mr-1 mb-1"></host-select>
            <gateway-select :model="filterFormModel" class="mr-1 mb-1"></gateway-select>
            <network-select :model="filterFormModel" class="mr-1 mb-1"></network-select>
            <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
        <div class="c-sorting" v-if="['admin', 'owner', 'account'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <call-fee-overview-export :data="data" :filter-form-model="filterFormModel"></call-fee-overview-export>
              </div>
            </div>
          </div>
        </div>
        <div class="tile">
          <div class="table-responsive c-template-table">
            <table class="table table-hover">
              <thead>
              <tr class="text-center">
                <th></th>
                <th v-if="filterFormModel.group === 'client'" >{{$t('sales')}}</th>
                <th v-if="filterFormModel.group === 'client'">{{$t('activeTime')}}</th>
                <th v-if="filterFormModel.group === 'client'">{{$t('createTime')}}</th>
                <th class="text-center">{{ $t('totalCall') }}</th>
                <th class="text-center">{{ $t('missCall') }}</th>
                <th class="text-center">{{ $t('successCount') }}</th>
                <th class="text-center">{{ $t('callFee') }}</th>
                <th class="text-center">{{ $t('offNetworkFee') }}</th>
                <th class="text-center">{{ $t('offNetwork') }}</th>
                <th class="text-center">{{ $t('chargeDuration') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr class="bg-success">
                <td><b class="text-uppercase">{{ $t('totals') }}</b></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td class="text-center"><span class="text-blue">{{ sum.total | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.missCall | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.success | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.chargedFee | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.offNetworkFee | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ sum.offNetwork | numFormat}}</span></td>
                <td class="text-center">{{ sum.chargeDuration | callDuration }}</td>
              </tr>
              <tr class="bg-warning">
                <td><b class="text-uppercase">{{ $t('avg') }}</b></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td v-if="filterFormModel.group === 'client'" ></td>
                <td class="text-center"><span class="text-blue">{{ avg.total | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.missCall | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.success | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.chargedFee | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.offNetworkFee | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ avg.offNetwork | numFormat}}</span></td>
                <td class="text-center">{{ avg.chargeDuration | callDuration }}</td>
              </tr>
              <tr :key="index" v-for="(item, index) in data">
                <td><b>{{ label(item) }}</b></td>
                <td class="text-center" v-if="filterFormModel.group === 'client'" >{{ item.clientSales }}</td>
                <td class="text-center" v-if="filterFormModel.group === 'client'" >{{ item.clientActiveTime | moment('DD/MM/YYYY')}}</td>
                <td class="text-center" v-if="filterFormModel.group === 'client'" >{{ item.clientCreateTime | moment('DD/MM/YYYY')}}</td>
                <td class="text-center"><span class="text-blue">{{ item.total | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.missCall | numFormat}}</span></td>
                <td class="text-center"><span>{{ item.success | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.chargedFee | numFormat}}</span></td>
                <td class="text-center"><span class="text-blue">{{ item.offNetworkFee | numFormat}}</span></td>
                <td class="text-center"><span>{{ item.offNetwork | numFormat}}</span></td>
                <td class="text-center">{{ item.chargeDuration | callDuration }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="tile">
          <div class="row">
            <div class="col">
              <div>
                <h3 class="tile-title">{{ $t('callFee') }}</h3>
                <apexchart :height="300" :options="chartOptions" :series="chargedFeeChartData"></apexchart>
              </div>
            </div>
          </div>
        </div>
        <div class="tile">
          <div class="row">
            <div class="col-md-6">
              <div class="tile shadow">
                <h3 class="tile-title">{{ $t('successCount') }}</h3>
                <apexchart :height="300" :options="chartOptions" :series="callChartData"></apexchart>
              </div>
            </div>
            <div class="col-md-6">
              <div class="tile shadow">
                <h3 class="tile-title">{{ $t('chargeDuration') }}</h3>
                <apexchart :height="300" :options="chartOptions" :series="durationChartData"></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeRangePicker from "../../components/TimeRangePicker";
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import ClientSelect from "../../components/ClientSelect";
import CallFeeOverviewExport from "@/views/report/CallFeeOverviewExport";
import HostSelect from "@/components/HostSelect";
import GatewaySelect from "@/components/GatewaySelect";
import NetworkSelect from "../../components/NetworkSelect";

export default {
  props: ['client'],
  components: {
    CallFeeOverviewExport, ClientSelect, TimeRangePicker, 'apexchart': VueApexCharts,
    NetworkSelect, HostSelect, GatewaySelect
  },
  data: function () {
    return {
      filterFormModel: {
        group: 'day',
        sort: 'chargedFee',
        client: this.client ? this.client._id : null,
        gateway: null,
        network: null,
        gatewayName: null,
        host: null,
      },
      gatewayNames: [],
      loading: true,
      data: [],
      chartOptions: {
        xaxis: {},
        chart: {
          zoom: {
            enabled: false
          },
          type: 'line'
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return new Intl.NumberFormat().format(value);
            }
          },
        },
      },
      callChartData: [],
      durationChartData: [],
      chargedFeeChartData: [],
      sum: {},
      avg: {},
    }
  },
  methods: {
    label(item) {
      if (item.label) {
        return item.label;
      }
      if (!isNaN(item._id)) {
        return moment(this.filterFormModel.from + item._id, 'x').format('ll');
      }
    },
    load() {
      let loader = this.$loading.show();
      this.$service.get('/report/call-fee', {
        params: this.filterFormModel
      }).then(response => {
        this.data = response.data;
        this.sum = {};
        this.avg = {};
        this.data.forEach(item => {
          for (let key in item) {
            if (!this.sum[key]) {
              this.sum[key] = 0;
            }
            this.sum[key] += item[key];
          }
        });
        for (let key in this.sum) {
          this.avg[key] = Math.round(this.sum[key] / this.data.length);
        }
        this.chartOptions = {
          xaxis: {
            categories: this.data.map(d => this.label(d)).slice(0, 99).reverse(),
            labels: {
              rotate: 0
            },
            tooltip: {
              enabled: false,
            }
          },
          chart: {
            zoom: {
              enabled: false
            },
            type: this.filterFormModel.group === 'day' ? 'line' : 'bar'
          }
        };
        this.loadChartData();
        if (this.filterFormModel.group !== 'day') {
          this.sort(this.filterFormModel.sort);
        }
      }).finally(() => {
        loader.hide();
      });
    },
    loadChartData() {
      this.callChartData = [
        {
          name: this.$t('successCount'),
          data: this.data.map(d => d.success).slice(0, 99).reverse(),
        },
        {
          name: this.$t('offNetwork'),
          data: this.data.map(d => d.offNetwork).slice(0, 99).reverse()
        }
      ];
      this.durationChartData = [
        {
          name: this.$t('chargeDuration'),
          data: this.data.map(d => d.chargeDuration).slice(0, 99).reverse(),
        }
      ];
      this.chargedFeeChartData = [
        {
          name: this.$t('callFee'),
          data: this.data.map(d => d.chargedFee).slice(0, 99).reverse(),
        },
        {
          name: this.$t('offNetworkFee'),
          data: this.data.map(d => d.offNetworkFee).slice(0, 99).reverse(),
        }
      ]
    },
    sort(criteria){
      this.data = this.data.sort((a, b) => b[criteria] - a[criteria]);
      this.loadChartData();
    },
    reset() {
      this.filterFormModel = {
        group: 'day',
        sort: 'chargedFee',
        client: this.client ? this.client._id : null,
        gateway: null,
        network: null,
        host: null,
        from: moment().subtract('6', 'day').startOf('day').valueOf(),
        to: moment().endOf('day').valueOf()
      };
      this.load()
    },
  },
  watch: {
    "filterFormModel.sort": {
      handler() {
        this.sort(this.filterFormModel.sort)
      }
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        callFee: 'Call fee',
        byDay: 'By day',
        byClient: 'By client',
        bySales: 'By sales',
        byAccounts: 'By supporter',
        byGateway: 'By gateway',
        byNumber: 'By number',
        sum: 'Sum',
        avg: 'Average',
        overview: 'Overview',
        detail: 'Detail',
        totals: 'Totals',
        successCount: 'Connected',
        chargeDuration: 'Charged duration',
        calls: 'Calls',
        duration: 'Duration',
        chargedFeeDesc: 'Charged fee descending',
        successDesc: 'Success call descending',
        chargeDurationDesc: 'Charged duration descending',
        offNetwork: 'Off network',
        offNetworkFee: 'Off network fee',
        offNetworkFeeDesc: 'Off network fee descending',
        offNetworkDesc: 'Off network descending',
        chooseGateway: 'Choose gateway name',
        gateway: 'Gateway',
        account: 'AM',
        activeTime: 'Active time',
        totalCall: "Total calls",
        missCall: "Missed call"
      },
      vi: {
        callFee: 'Cước gọi',
        byDay: 'Theo ngày',
        byClient: 'Theo client',
        bySales: 'Theo sales',
        byAccounts: 'Theo chăm sóc',
        byGateway: 'Theo gateway',
        byNumber: 'Theo số gọi ra',
        sum: 'Tổng',
        avg: 'Trung bình',
        overview: 'Tổng quan',
        detail: 'Chi tiết',
        totals: 'Tổng',
        successCount: 'Kết nối thành công',
        chargeDuration: 'Thời lượng tính phí',
        calls: 'Cuộc gọi',
        duration: 'Thời lượng',
        chargedFeeDesc: 'Cước gọi giảm dần',
        successDesc: 'Cuộc gọi thành công giảm dần',
        chargeDurationDesc: 'Thời lượng tính phí giảm dần',
        offNetwork: 'Số cuộc ngoại mạng',
        offNetworkFee: 'Cước gọi ngoại mạng',
        offNetworkFeeDesc: 'Cước gọi ngoại mạng giảm dần',
        offNetworkDesc: 'Số cuộc gọi ngoại mạng giảm dần',
        chooseGateway: 'Chọn tên gateway',
        gateway: 'Gateway',
        account: 'AM',
        activeTime: 'Kích hoạt lúc',
        totalCall: "Số lượng cuộc gọi",
        missCall: "Gọi nhỡ"
      }
    }
  }
}
</script>
